import { useState } from 'react';
import { X } from 'lucide-react';

interface Review {
  initials: string;
  name: string;
  rating: number;
  review: string;
  source: string;
}

export default function ReviewsSection() {
  const [selectedReview, setSelectedReview] = useState<Review | null>(null);
  
  const truncateText = (text: string, maxLength: number = 200) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };
  
  const openModal = (review: Review) => {
    setSelectedReview(review);
  };
  
  const closeModal = () => {
    setSelectedReview(null);
  };
  return (
    <section className="py-20 bg-gradient-to-br from-white via-primary-50/30 to-secondary-50/30 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-32 h-32 bg-gradient-to-br from-primary-400 to-secondary-400 rounded-full blur-2xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-gradient-to-tl from-secondary-400 to-primary-400 rounded-full blur-2xl"></div>
      </div>
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-primary-800 to-secondary-700 bg-clip-text text-transparent">
              Ce que disent nos utilisateurs
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Découvrez les témoignages de notre communauté grandissante
          </p>
        </div>
        <div className="relative overflow-hidden pb-8">
          <div className="flex animate-scroll space-x-8 overflow-x-auto md:overflow-visible scrollbar-hide">
            {/* First set of reviews */}
            {[{
		name: "Lessoinsetbijouxdecamille",
		initials: "L",
		review: "Une appli de bien être complet, qui regroupe tout ce que l’on a besoin pour aller mieux",
		rating: 5,
		source: "App Store"
	},
	{
		name: "Marine V",
		initials: "MV",
		review: "Une super application. Facile d'utilisation et qui apporte énormément ! Merci 😊",
		rating: 5,
		source: "Google Play"
	},
	{
		name: "Michèle22",
		initials: "M",
		review: "Super application qui regroupe plein d'outils différents qui nous permettent à tout moment de se sentir mieux et de rester sur son chemin. Je recommande vivement 🥰",
		rating: 5,
		source: "App Store"
	},
	{
		name: "Sylvie",
		initials: "S",
		review: "Superbe application, contenu de grande qualité et très aidant.",
		rating: 5,
		source: "Google Play"
	},
	{
		name: "Rêve D’Azur",
		initials: "RA",
		review: "WeZen est une véritable pépite pour celles et ceux qui souhaitent améliorer leur bien-être et trouver un équilibre intérieur. L’interface est fluide et agréable, rendant la méditation accessible à tous, que l’on soit débutant ou expérimenté. J’apprécie particulièrement la diversité des séances proposées : méditations guidées, exercices de respiration, moments de relaxation… Tout est conçu pour nous aider à lâcher prise et à mieux gérer le stress du quotidien. Depuis que j’utilise WeZen, je ressens une réelle différence : plus de sérénité, un sommeil amélioré et une meilleure concentration au quotidien. C’est devenu un véritable rituel que je recommande à 100 % ! Merci à l’équipe derrière cette application pour leur travail exceptionnel. Si vous hésitez encore, foncez, vous ne serez pas déçu",
		rating: 5,
		source: "App Store"
	},
  {
		name: "Maria Persichetti",
		initials: "MP",
		review: "Je me recentre sur moi même et mon bien être. Moins énervé et Sommeil plus réparateur",
		rating: 5,
		source: "Google Play"
	},
	{
		name: "Kilindy 13",
		initials: "K",
		review: "Application entièrement gratuite avec un vrai contenu, varié, adapté, qui vous apporte le bien être en agissant sur plusieurs sujets : méditation, nutrition, hypnose, respiration,…. Une application à avoir.",
		rating: 5,
		source: "App Store"
	},
	{
		name: "Alex Eger",
		initials: "AE",
		review: "Super appli! Très complète sur le bien-être. C'est devenue une aide au quotidien grâce à ses exercices de médiation, d'hypnose et de respiration. Tout pour se sentir bien. J'adore !",
		rating: 5,
		source: "Google Play"
	},
	{
		name: "Fifo Cancun",
		initials: "FC",
		review: "Application basée sur le bien être, la motivation, le lâcher prise, la confiance en soi et le déstress. Il y a aussi plein de recettes détox, d’exercices, d’articles … c’est très complet je suis loin d’avoir tout découvert. Exemple : j’ai de grosses difficultés à m’endormir mais depuis que j’écoute la partie «sommeil » de l’application je m’endors directement, idem quand je me tracasse pour quelqu’un j’utilise l’application pour diminuer mon anxiété et : ÇA MARCHE ! En plus si vous avez le moindre problème le service clientèle est incroyable, ils vous répondent immédiatement et vous assistez vraiment. Bref je recommande 100%",
		rating: 5,
		source: "App Store"
	},
	{
		name: "Dorddord",
		initials: "D",
		review: "N’étant pas un amateur des applications de méditations / relaxations, WeZen vient s’opposer comme un excellente alternative aux autres supports ! Excellente personnalisation des méditations. Je recommande vivement !",
		rating: 5,
		source: "App Store"
	},
	{
		name: "Sonia Candros",
		initials: "SC",
		review: "Une application complète qui m'accompagne au quotidien. Je trouve les méditations bien plus efficace que d'autres applis et les recettes sont top.",
		rating: 5,
		source: "Google Play"
	},
	{
		name: "FalleyOwO",
		initials: "F",
		review: "Excellente application ! WeZen est intuitif, fluide et vraiment bien conçu. L’interface est agréable et facile à prendre en main, même pour les débutants. Les fonctionnalités sont complètes et répondent parfaitement aux attentes. De plus, l’application est stable et performante, sans bugs gênants. Un grand bravo aux développeurs pour ce travail de qualité ! Je recommande vivement.",
		rating: 5,
		source: "App Store"
	},
	{
		name: "Ukichiro",
		initials: "U",
		review: "Je viens de découvrir cette application et elle est vraiment géniale, ça change des autres applications similaire, elle est très complète",
		rating: 5,
		source: "Google Play"
	},
	{
		name: "Casaaa23",
		initials: "C",
		review: "Programme personnalisé et complet que demander de mieux ! Plutôt que de télécharger 15 applis différentes pour chaque thème autant en avoir une seule qui fait tout ! Je me régale, c’est très simple d’utilisation, et ce que l’appli nous propose est vraiment efficace et fait du bien ! Alors n’hésitez plus et foncez vous n’avez rien à perdre !",
		rating: 5,
		source: "App Store"
	},
	{
		name: "Chantal Ana",
		initials: "CA",
		review: "J adore cette application 😍Très facile à utiliser et très complet également concernant le bien-être. C'est mon application préférée pour m'aider à aller bien chaque jour ! Merci WeeZen et bravo à vous !",
		rating: 5,
		source: "Google Play"
	},
	{
		name: "Abrahameee",
		initials: "A",
		review: "Moi qui suis un grand stressée, je chercher une application pour me motiver, bah je crois j’ai trouver sa me change des autres applications, l’application est rapide et pas bug, y’a de bonne fonctionnalité j’adore 😇",
		rating: 5,
		source: "App Store"
	},
	{
		name: "Granaola",
		initials: "G",
		review: "Très bonne application pour les personnes ayant besoin d'un peu de réconfort, de confiance en soi et même en petite recette détox ! Et plein d'autres Je recommande vivement",
		rating: 5,
		source: "Google Play"
	},
	{
		name: "Dicecca Cat",
		initials: "DC",
		review: "J'adore l'application Wezen ! Elle est géniale, adaptée et personnalisée. Le large choix de musique gratuite pour la méditation, la relaxation et le développement personnel est incroyable. De plus, les articles intéressants ajoutent une réelle valeur à l'expérience. Je débute à peine, mais je trouve déjà cette application très complète et enrichissante. Enfin une application qui me correspond",
		rating: 5,
		source: "Google Play"
	}
].map((review, index) => (
              <div key={index} className="flex-shrink-0 w-80 bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 group">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-primary-400 to-secondary-400 rounded-full flex items-center justify-center text-white font-bold mr-4 group-hover:scale-110 transition-transform">
                    {review.initials}
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800">{review.name}</h4>
                    <div className="flex items-center gap-1">
                      {[...Array(review.rating)].map((_, i) => (
                        <span key={i} className="text-yellow-400 text-sm">★</span>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="text-gray-600 mb-4 leading-relaxed">
                  <p>{truncateText(review.review)}</p>
                  {review.review.length > 200 && (
                    <button 
                      onClick={() => openModal(review)}
                      className="text-primary-600 hover:text-primary-700 text-sm font-medium mt-2 transition-colors"
                    >
                      Voir plus
                    </button>
                  )}
                </div>
                <div className="text-xs text-gray-400 bg-gray-50 px-3 py-1 rounded-full inline-block">
                  {review.source}
                </div>
              </div>
            ))}
            {/* Duplicate set for infinite scroll */}
            {[{
		name: "Lessoinsetbijouxdecamille",
		initials: "L",
		review: "Une appli de bien être complet, qui regroupe tout ce que l'on a besoin pour aller mieux",
		rating: 5,
		source: "App Store"
	},
	{
		name: "Marine V",
		initials: "MV",
		review: "Une super application. Facile d'utilisation et qui apporte énormément ! Merci 😊",
		rating: 5,
		source: "Google Play"
	},
	{
		name: "Michèle22",
		initials: "M",
		review: "Super application qui regroupe plein d'outils différents qui nous permettent à tout moment de se sentir mieux et de rester sur son chemin. Je recommande vivement 🥰",
		rating: 5,
		source: "App Store"
	},
	{
		name: "Sylvie",
		initials: "S",
		review: "Superbe application, contenu de grande qualité et très aidant.",
		rating: 5,
		source: "Google Play"
	},
	{
		name: "Rêve D'Azur",
		initials: "RA",
		review: "WeZen est une véritable pépite pour celles et ceux qui souhaitent améliorer leur bien-être et trouver un équilibre intérieur. L'interface est fluide et agréable, rendant la méditation accessible à tous, que l'on soit débutant ou expérimenté. J'apprécie particulièrement la diversité des séances proposées : méditations guidées, exercices de respiration, moments de relaxation… Tout est conçu pour nous aider à lâcher prise et à mieux gérer le stress du quotidien. Depuis que j'utilise WeZen, je ressens une réelle différence : plus de sérénité, un sommeil amélioré et une meilleure concentration au quotidien. C'est devenu un véritable rituel que je recommande à 100 % ! Merci à l'équipe derrière cette application pour leur travail exceptionnel. Si vous hésitez encore, foncez, vous ne serez pas déçu",
		rating: 5,
		source: "App Store"
	},
  {
		name: "Maria Persichetti",
		initials: "MP",
		review: "Je me recentre sur moi même et mon bien être. Moins énervé et Sommeil plus réparateur",
		rating: 5,
		source: "Google Play"
	},
	{
		name: "Kilindy 13",
		initials: "K",
		review: "Application entièrement gratuite avec un vrai contenu, varié, adapté, qui vous apporte le bien être en agissant sur plusieurs sujets : méditation, nutrition, hypnose, respiration,…. Une application à avoir.",
		rating: 5,
		source: "App Store"
	},
	{
		name: "Alex Eger",
		initials: "AE",
		review: "Super appli! Très complète sur le bien-être. C'est devenue une aide au quotidien grâce à ses exercices de médiation, d'hypnose et de respiration. Tout pour se sentir bien. J'adore !",
		rating: 5,
		source: "Google Play"
	},
	{
		name: "Fifo Cancun",
		initials: "FC",
		review: "Cette application est vraiment géniale ! Elle offre une multitude de fonctionnalités pour améliorer le bien-être au quotidien. Les méditations guidées sont apaisantes et parfaitement adaptées à différents moments de la journée. Les exercices de respiration sont simples mais très efficaces pour gérer le stress. J'apprécie aussi les conseils nutritionnels qui sont pratiques et faciles à suivre. L'interface est intuitive et agréable à utiliser. C'est devenu un incontournable de ma routine bien-être. Je la recommande vivement à tous ceux qui cherchent à améliorer leur qualité de vie !",
		rating: 5,
		source: "App Store"
	},
	{
		name: "Dicecca Cat",
		initials: "DC",
		review: "J'adore l'application Wezen ! Elle est géniale, adaptée et personnalisée. Le large choix de musique gratuite pour la méditation, la relaxation et le développement personnel est incroyable. De plus, les articles intéressants ajoutent une réelle valeur à l'expérience. Je débute à peine, mais je trouve déjà cette application très complète et enrichissante. Enfin une application qui me correspond",
		rating: 5,
		source: "Google Play"
	}
].map((review, index) => (
              <div key={`duplicate-${index}`} className="flex-shrink-0 w-80 bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 group">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-primary-400 to-secondary-400 rounded-full flex items-center justify-center text-white font-bold mr-4 group-hover:scale-110 transition-transform">
                    {review.initials}
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800">{review.name}</h4>
                    <div className="flex items-center gap-1">
                      {[...Array(review.rating)].map((_, i) => (
                        <span key={i} className="text-yellow-400 text-sm">★</span>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="text-gray-600 mb-4 leading-relaxed">
                  <p>{truncateText(review.review)}</p>
                  {review.review.length > 200 && (
                    <button 
                      onClick={() => openModal(review)}
                      className="text-primary-600 hover:text-primary-700 text-sm font-medium mt-2 transition-colors"
                    >
                      Voir plus
                    </button>
                  )}
                </div>
                <div className="text-xs text-gray-400 bg-gray-50 px-3 py-1 rounded-full inline-block">
                  {review.source}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* Modal */}
      {selectedReview && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl p-6 max-w-2xl w-full max-h-[80vh] overflow-y-auto relative">
            <button 
              onClick={closeModal}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="w-6 h-6" />
            </button>
            
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-primary-400 to-secondary-400 rounded-full flex items-center justify-center text-white font-bold mr-4 text-xl">
                {selectedReview.initials}
              </div>
              <div>
                <h3 className="font-bold text-xl text-gray-800">{selectedReview.name}</h3>
                <div className="flex items-center gap-1 mb-2">
                  {[...Array(selectedReview.rating)].map((_, i) => (
                    <span key={i} className="text-yellow-400 text-lg">★</span>
                  ))}
                </div>
                <div className="text-sm text-gray-400 bg-gray-50 px-3 py-1 rounded-full inline-block">
                  {selectedReview.source}
                </div>
              </div>
            </div>
            
            <p className="text-gray-700 leading-relaxed text-lg">
              {selectedReview.review}
            </p>
          </div>
        </div>
      )}
    </section>
  );
}
